import type { ReactNode } from "react";
export function FormField({
    label,
    required,
    hint,
    children,
    className = "",
}: {
    label: string;
    required?: boolean;
    hint?: string;
    children: ReactNode;
    className?: string;
}) {
    return (
        <label className={`form-field ${className}`}>
            <span>
                {label}
                {required ? <b> *</b> : null}
            </span>
            {children}
            {hint ? <small>{hint}</small> : null}
        </label>
    );
}
